import { Flex, Text } from '@chakra-ui/react'
import Drawer from '@mui/material/Drawer'
import TextField from '@mui/material/TextField'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { useState } from 'react'
import { FaFilter } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { iEmpresaMultiAcesso } from '../../../../contexts/AuthContext'

export interface iFiltroLogAuditoria {
  dataInicio: string
  dataFim: string
  usuario: string
  empresaId: string
}

interface iDrawProps {
  isOpen: boolean
  onClose: () => void
  onRedefinir: () => void
  onFilter: (filtro: iFiltroLogAuditoria) => void
  startValue?: iFiltroLogAuditoria
  empresas?: iEmpresaMultiAcesso[]
}

const filtroVazio: iFiltroLogAuditoria = { dataInicio: '', dataFim: '', usuario: '', empresaId: '' }

export const DrawerFiltro: React.FC<iDrawProps> = ({ isOpen, onClose, onRedefinir, onFilter, startValue, empresas }) => {
  const theme = createTheme({
    typography: {
      fontFamily: [
        'NotoSans',
        'NotoSansThai',
        'Arial',
        'Roboto',
        "'Helvetica Neue'",
        'sans-serif'
      ].join(',')
    },
    shape: {
      borderRadius: 15
    }
  })

  const [Filtro, setFiltro] = useState<iFiltroLogAuditoria>(startValue ?? filtroVazio)

  return (
    <ThemeProvider theme={theme}>
      <Drawer
        open={isOpen}
        anchor={'right'}
        onClose={onClose}
        role={'presentation'}
      >
        <Flex p={'1.5rem'} flexDir={'column'} gap={'.75rem'}>
          <Flex width={'100%'} justifyContent={'space-between'} pb={'.75rem'} borderBottom={'1px solid var(--c3)'}>
            <Text fontSize={'.875rem'}>Filtros</Text>
            <MdClose onClick={onClose} size={18} />
          </Flex>

          <Flex gap={'.75rem'} flexDir={'column'}>
            <TextField
              label='Data inicial'
              type='date'
              size='small'
              InputLabelProps={{ shrink: true }}
              value={Filtro.dataInicio}
              onChange={(e) => setFiltro({ ...Filtro, dataInicio: e.target.value })}
              style={{ width: '20rem' }}
            />
            <TextField
              label='Data final'
              type='date'
              size='small'
              InputLabelProps={{ shrink: true }}
              value={Filtro.dataFim}
              onChange={(e) => setFiltro({ ...Filtro, dataFim: e.target.value })}
              style={{ width: '20rem' }}
            />
            {empresas && (
              <TextField
                select
                label='Empresa'
                size='small'
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                value={Filtro.empresaId}
                onChange={(e) => setFiltro({ ...Filtro, empresaId: e.target.value })}
                style={{ width: '20rem' }}
              >
                <option value=''>Todas</option>
                {empresas.map(e => <option key={e.empresaId} value={e.empresaId}>{e.nome}</option>)}
              </TextField>
            )}
            <TextField
              label='Usuário'
              type='text'
              size='small'
              value={Filtro.usuario}
              onChange={(e) => setFiltro({ ...Filtro, usuario: e.target.value })}
              style={{ width: '20rem' }}
            />

            <Flex gap={'.5rem'} justifyContent={'end'}>
              <ButtonCmp VarColor='c6' onClick={() => { setFiltro(filtroVazio); onRedefinir() }}>Redefinir filtros</ButtonCmp>
              <ButtonCmp VarColor='Green2' leftIcon={<FaFilter />} onClick={() => onFilter(Filtro)}>
                Filtrar
              </ButtonCmp>
            </Flex>
          </Flex>
        </Flex>
      </Drawer>
    </ThemeProvider>
  )
}
